module.exports = __webpack_public_path__ + "static/gs1-sm-26bdfab27e4411579dae12fe07eb03cf.jpg";